import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { FormBuilder} from '@angular/forms';

import {I18nService, AuthenticationService} from '@app/core';
import {Http} from '@angular/http';
import {AuthService, SocialUser} from 'angularx-social-login';
import {UtilityService} from '../core/utils.service';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  shoppingName: string;
  constructor(private router: Router,
              private route: ActivatedRoute,
              private formBuilder: FormBuilder,
              private i18nService: I18nService,
              private authenticationService: AuthenticationService,
              private http: Http,
              private authService: AuthService,
              private util: UtilityService) {
    this.util.setBarBackground();
    this.util.setBarTextColor();

      this.route.params.subscribe( params => {
          console.log(params.shoppingName);
          this.shoppingName = params.shoppingName;
      } );
  }

  user: SocialUser;

  ngOnInit() {
    this.authService.signOut();
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/login-page/login-page.component.ts